import { PassouFalhouEnum } from '@mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { hasAnySim, isAllNao } from '@mchat-rf/consulta-seguimento/utils-consultaSeguimento'
import { isEmpty } from 'bold-ui'
import { SimNaoEnum } from 'components/form'

import {
  ConsultaSeguimentoPergunta08ForaAlcanceEnum,
  ConsultaSeguimentoPergunta08Model,
} from './model-consultaSeguimentoPergunta08'

const pergunta08ForaAlcanceEnum = Object.values(ConsultaSeguimentoPergunta08ForaAlcanceEnum)

export const isPergunta08ForaAlcanceAllNao = (
  value: ConsultaSeguimentoPergunta08Model['PERGUNTA_08_FORA_ALCANCE']
): boolean => {
  return isAllNao(value, pergunta08ForaAlcanceEnum)
}

export function prunePergunta08(value: ConsultaSeguimentoPergunta08Model): ConsultaSeguimentoPergunta08Model {
  const pruned: ConsultaSeguimentoPergunta08Model = {
    status: value.status,
    resultado: value.resultado,
    PERGUNTA_08_HEADER: value.PERGUNTA_08_HEADER,
  }

  const isHeaderSim = value.PERGUNTA_08_HEADER === SimNaoEnum.SIM
  const isHeaderNao = value.PERGUNTA_08_HEADER === SimNaoEnum.NAO
  const isSeInteressaPorNao = value.PERGUNTA_08_SE_INTERESSA_POR === SimNaoEnum.NAO
  const isRespondePerguntasSim = value.PERGUNTA_08_RESPONDE_PERGUNTAS === SimNaoEnum.SIM
  const isNotForaAlcanceAllNao = !isPergunta08ForaAlcanceAllNao(value.PERGUNTA_08_FORA_ALCANCE)

  if (isHeaderSim) {
    pruned.PERGUNTA_08_SE_INTERESSA_POR = value.PERGUNTA_08_SE_INTERESSA_POR
  }

  if (isSeInteressaPorNao || isHeaderNao) {
    pruned.PERGUNTA_08_RESPONDE_PERGUNTAS = value.PERGUNTA_08_RESPONDE_PERGUNTAS

    if (isRespondePerguntasSim) {
      pruned.PERGUNTA_08_FORA_ALCANCE = value.PERGUNTA_08_FORA_ALCANCE

      if (isNotForaAlcanceAllNao) {
        pruned.PERGUNTA_08_RESPONDE_CRIANCAS = value.PERGUNTA_08_RESPONDE_CRIANCAS
      }
    }
  }

  return pruned
}

export function conditionToCalculatePergunta08(values: ConsultaSeguimentoPergunta08Model): boolean {
  const isHeaderSimESeInteressaPor =
    values.PERGUNTA_08_HEADER === SimNaoEnum.SIM && values.PERGUNTA_08_SE_INTERESSA_POR === SimNaoEnum.SIM

  if (isHeaderSimESeInteressaPor) {
    return true
  }

  const isHeaderNaoOuHeaderSimENaoSeInteressaPor =
    values.PERGUNTA_08_HEADER === SimNaoEnum.NAO ||
    (values.PERGUNTA_08_HEADER === SimNaoEnum.SIM && values.PERGUNTA_08_SE_INTERESSA_POR === SimNaoEnum.NAO)

  if (!isHeaderNaoOuHeaderSimENaoSeInteressaPor) {
    return false
  }

  const isRespondePerguntasNao = values.PERGUNTA_08_RESPONDE_PERGUNTAS === SimNaoEnum.NAO
  const isForaAlcanceTodosNao = isPergunta08ForaAlcanceAllNao(values.PERGUNTA_08_FORA_ALCANCE)
  const hasRespondeCriancas =
    hasAnySim(values.PERGUNTA_08_FORA_ALCANCE) && !isEmpty(values.PERGUNTA_08_RESPONDE_CRIANCAS)

  return isRespondePerguntasNao || isForaAlcanceTodosNao || hasRespondeCriancas
}

export function calculateResultadoPergunta08(values: ConsultaSeguimentoPergunta08Model): PassouFalhouEnum | undefined {
  if (values.PERGUNTA_08_HEADER === SimNaoEnum.SIM && values.PERGUNTA_08_SE_INTERESSA_POR === SimNaoEnum.SIM) {
    return PassouFalhouEnum.PASSOU
  } else if (values.PERGUNTA_08_RESPONDE_PERGUNTAS === SimNaoEnum.NAO) {
    return PassouFalhouEnum.FALHOU
  } else if (isPergunta08ForaAlcanceAllNao(values.PERGUNTA_08_FORA_ALCANCE)) {
    return PassouFalhouEnum.FALHOU
  } else if (hasAnySim(values.PERGUNTA_08_FORA_ALCANCE) && values.PERGUNTA_08_RESPONDE_CRIANCAS === SimNaoEnum.SIM) {
    return PassouFalhouEnum.PASSOU
  } else if (hasAnySim(values.PERGUNTA_08_FORA_ALCANCE) && values.PERGUNTA_08_RESPONDE_CRIANCAS === SimNaoEnum.NAO) {
    return PassouFalhouEnum.FALHOU
  }
}
